export default "__VITE_ASSET__CcO7BLkb__"